/**
 * <s-page-toc data-source="ID">
 * Builds an in-page table of contents from the h2/h3 headings inside the
 * element with the given id. Adds ids to headings that lack one. Stays hidden
 * when fewer than two headings exist.
 */
class SPageToc extends HTMLElement {
  connectedCallback() {
    const source = document.getElementById(this.dataset.source || '');
    const list = this.querySelector('[data-toc-list]');
    if (!source || !list) return;

    const headings = [...source.querySelectorAll('h2, h3')].filter((h) => h.textContent.trim());
    if (headings.length < 2) return;

    const used = new Set();
    for (const heading of headings) {
      if (!heading.id) {
        let base = heading.textContent.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || 'section';
        let id = base;
        let n = 2;
        while (used.has(id) || document.getElementById(id)) id = `${base}-${n++}`;
        heading.id = id;
      }
      used.add(heading.id);

      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent.trim();
      link.className = heading.tagName === 'H3' ? 'block py-1 ps-3 text-sm text-on-surface-secondary no-underline hover:text-heading' : 'block py-1 text-sm font-semibold text-heading no-underline hover:underline';
      item.append(link);
      list.append(item);
    }
    this.hidden = false;
  }
}

if (!customElements.get('s-page-toc')) {
  customElements.define('s-page-toc', SPageToc);
}
